export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";

export const SET_MESSAGE = "SET_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";

export const PROFILE_INFO = "PROFILE_INFO";
export const PROFILE_PHOTO = "PROFILE_PHOTO";
export const PROFILE_TIMEZONE = "PROFILE_TIMEZONE";
export const CHANGE_TIMEZONE = "CHANGE_TIMEZONE";

export const MEMBERS_LIST = "MEMBERS_LIST";
export const TEAM_MEMBERS = "TEAM_MEMBERS";
export const EDIT_MEMBER = "EDIT_MEMBER";
export const ADD_MEMBER = "ADD_MEMBER";
export const BAMBOOHR_EMPLOYEES = "BAMBOOHR_EMPLOYEES";

export const PROFILE_TEAMS = "PROFILE_TEAMS";
export const EDIT_TEAMS = "EDIT_TEAMS";
export const ADD_TEAM = "ADD_TEAM";
export const DELETE_TEAM = "DELETE_TEAM";

export const SCHEDULES = "SCHEDULES";
export const EMAILS = "EMAILS";
export const ROLES = "ROLES";
export const HAS_ACCOUNT = "HAS_ACCOUNT";

export const SET_PERMISSIONS = "PERMISSIONS";

export const SET_CUSTOMIZATION = "CUSTOMIZATION";
export const SET_LOGO_URL = "LOGO_URL";
export const SET_SMALL_LOGO_URL = "SMALL_LOGO_URL";

export const FETCH_RFQ_NOTIFICATION_RULES_REQUEST = "FETCH_RFQ_NOTIFICATION_RULES_REQUEST";
export const FETCH_RFQ_NOTIFICATION_RULES_SUCCESS = "FETCH_RFQ_NOTIFICATION_RULES_SUCCESS";
export const FETCH_RFQ_NOTIFICATION_RULES_FAILURE = "FETCH_RFQ_NOTIFICATION_RULES_FAILURE";

export const CREATE_RFQ_NOTIFICATION_RULE_REQUEST = "CREATE_RFQ_NOTIFICATION_RULE_REQUEST";
export const CREATE_RFQ_NOTIFICATION_RULE_SUCCESS = "CREATE_RFQ_NOTIFICATION_RULE_SUCCESS";
export const CREATE_RFQ_NOTIFICATION_RULE_FAILURE = "CREATE_RFQ_NOTIFICATION_RULE_FAILURE";

export const UPDATE_RFQ_NOTIFICATION_RULE_REQUEST = "UPDATE_RFQ_NOTIFICATION_RULE_REQUEST";
export const UPDATE_RFQ_NOTIFICATION_RULE_SUCCESS = "UPDATE_RFQ_NOTIFICATION_RULE_SUCCESS";
export const UPDATE_RFQ_NOTIFICATION_RULE_FAILURE = "UPDATE_RFQ_NOTIFICATION_RULE_FAILURE";

export const DELETE_RFQ_NOTIFICATION_RULE_REQUEST = "DELETE_RFQ_NOTIFICATION_RULE_REQUEST";
export const DELETE_RFQ_NOTIFICATION_RULE_SUCCESS = "DELETE_RFQ_NOTIFICATION_RULE_SUCCESS";
export const DELETE_RFQ_NOTIFICATION_RULE_FAILURE = "DELETE_RFQ_NOTIFICATION_RULE_FAILURE";

export const FETCH_CONTACTS_WITH_STATS_REQUEST = "FETCH_CONTACTS_WITH_STATS_REQUEST";
export const FETCH_CONTACTS_WITH_STATS_SUCCESS = "FETCH_CONTACTS_WITH_STATS_SUCCESS";
export const FETCH_CONTACTS_WITH_STATS_FAILURE = "FETCH_CONTACTS_WITH_STATS_FAILURE";
export const FETCH_CONTACTS_WITH_STATS_CANCELLED = "FETCH_CONTACTS_WITH_STATS_CANCELLED";

export const TEST_RFQ_NOTIFICATION_RULE_REQUEST = "TEST_RFQ_NOTIFICATION_RULE_REQUEST";
export const TEST_RFQ_NOTIFICATION_RULE_SUCCESS = "TEST_RFQ_NOTIFICATION_RULE_SUCCESS";
export const TEST_RFQ_NOTIFICATION_RULE_FAILURE = "TEST_RFQ_NOTIFICATION_RULE_FAILURE";

export const CLEAR_RFQ_NOTIFICATIONS_ERROR = "CLEAR_RFQ_NOTIFICATIONS_ERROR";
export const FETCH_RFQ_NOTIFICATION_RULE_DETAILS_REQUEST = "FETCH_RFQ_NOTIFICATION_RULE_DETAILS_REQUEST";
export const FETCH_RFQ_NOTIFICATION_RULE_DETAILS_SUCCESS = "FETCH_RFQ_NOTIFICATION_RULE_DETAILS_SUCCESS";
export const FETCH_RFQ_NOTIFICATION_RULE_DETAILS_FAILURE = "FETCH_RFQ_NOTIFICATION_RULE_DETAILS_FAILURE";
export const CLEAR_CURRENT_RULE = "CLEAR_CURRENT_RULE";
export const FETCH_RFQ_SOURCES_REQUEST = "FETCH_RFQ_SOURCES_REQUEST";
export const FETCH_RFQ_SOURCES_SUCCESS = "FETCH_RFQ_SOURCES_SUCCESS";
export const FETCH_RFQ_SOURCES_FAILURE = "FETCH_RFQ_SOURCES_FAILURE";

// Schedule action types
export const FETCH_SCHEDULES_REQUEST = "FETCH_SCHEDULES_REQUEST";
export const FETCH_SCHEDULES_SUCCESS = "FETCH_SCHEDULES_SUCCESS";
export const FETCH_SCHEDULES_FAILURE = "FETCH_SCHEDULES_FAILURE";

export const CREATE_SCHEDULE_REQUEST = "CREATE_SCHEDULE_REQUEST";
export const CREATE_SCHEDULE_SUCCESS = "CREATE_SCHEDULE_SUCCESS";
export const CREATE_SCHEDULE_FAILURE = "CREATE_SCHEDULE_FAILURE";

export const UPDATE_SCHEDULE_REQUEST = "UPDATE_SCHEDULE_REQUEST";
export const UPDATE_SCHEDULE_SUCCESS = "UPDATE_SCHEDULE_SUCCESS";
export const UPDATE_SCHEDULE_FAILURE = "UPDATE_SCHEDULE_FAILURE";

export const DELETE_SCHEDULE_REQUEST = "DELETE_SCHEDULE_REQUEST";
export const DELETE_SCHEDULE_SUCCESS = "DELETE_SCHEDULE_SUCCESS";
export const DELETE_SCHEDULE_FAILURE = "DELETE_SCHEDULE_FAILURE";

export const BULK_CREATE_SCHEDULES_REQUEST = "BULK_CREATE_SCHEDULES_REQUEST";
export const BULK_CREATE_SCHEDULES_SUCCESS = "BULK_CREATE_SCHEDULES_SUCCESS";
export const BULK_CREATE_SCHEDULES_FAILURE = "BULK_CREATE_SCHEDULES_FAILURE";

// Contact Blacklist action types
export const FETCH_CONTACT_BLACKLIST_REQUEST = "FETCH_CONTACT_BLACKLIST_REQUEST";
export const FETCH_CONTACT_BLACKLIST_SUCCESS = "FETCH_CONTACT_BLACKLIST_SUCCESS";
export const FETCH_CONTACT_BLACKLIST_FAILURE = "FETCH_CONTACT_BLACKLIST_FAILURE";

export const ADD_BLACKLIST_ENTRY_REQUEST = "ADD_BLACKLIST_ENTRY_REQUEST";
export const ADD_BLACKLIST_ENTRY_SUCCESS = "ADD_BLACKLIST_ENTRY_SUCCESS";
export const ADD_BLACKLIST_ENTRY_FAILURE = "ADD_BLACKLIST_ENTRY_FAILURE";

export const UPDATE_BLACKLIST_ENTRY_REQUEST = "UPDATE_BLACKLIST_ENTRY_REQUEST";
export const UPDATE_BLACKLIST_ENTRY_SUCCESS = "UPDATE_BLACKLIST_ENTRY_SUCCESS";
export const UPDATE_BLACKLIST_ENTRY_FAILURE = "UPDATE_BLACKLIST_ENTRY_FAILURE";

export const DELETE_BLACKLIST_ENTRY_REQUEST = "DELETE_BLACKLIST_ENTRY_REQUEST";
export const DELETE_BLACKLIST_ENTRY_SUCCESS = "DELETE_BLACKLIST_ENTRY_SUCCESS";
export const DELETE_BLACKLIST_ENTRY_FAILURE = "DELETE_BLACKLIST_ENTRY_FAILURE";

export const FETCH_AVAILABLE_CONTACTS_REQUEST = "FETCH_AVAILABLE_CONTACTS_REQUEST";
export const FETCH_AVAILABLE_CONTACTS_SUCCESS = "FETCH_AVAILABLE_CONTACTS_SUCCESS";
export const FETCH_AVAILABLE_CONTACTS_FAILURE = "FETCH_AVAILABLE_CONTACTS_FAILURE";

export const SET_BLACKLIST_FILTERS = "SET_BLACKLIST_FILTERS";
export const CLEAR_BLACKLIST_ERROR = "CLEAR_BLACKLIST_ERROR";
export const RESET_BLACKLIST_STATE = "RESET_BLACKLIST_STATE";
